module.exports = __webpack_public_path__ + "img/05.16782bbb.jpg";